import { createFileRoute } from '@tanstack/react-router';
import { AdminDisputesPage } from '../../features/disputes';

export const Route = createFileRoute('/admin/disputes/')({ component: AdminDisputesPage });
